
import { useMutation } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const useMembershipPurchase = () => {
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (data: {
      membershipId: string;
      successUrl?: string;
      cancelUrl?: string;
      userCouponId?: string;
      discountAmount?: number;
    }) => {
      console.log('Creating membership payment:', data);
      
      const { data: result, error } = await supabase.functions.invoke('create-membership-payment', {
        body: data,
      });

      if (error) {
        console.error('Payment creation error:', error);
        throw error;
      }

      return result;
    },
    onSuccess: (data) => {
      console.log('Payment session created:', data);
      if (data.url) {
        // Redirect to Stripe checkout
        window.location.href = data.url;
      }
    },
    onError: (error) => {
      console.error('Membership purchase error:', error);
      toast({
        title: "Payment Error",
        description: "Failed to create payment session. Please try again.",
        variant: "destructive",
      });
    },
  });
};

export const useVerifyMembershipPayment = () => {
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (sessionId: string) => {
      console.log('Verifying membership payment:', sessionId);
      
      const { data: result, error } = await supabase.functions.invoke('verify-membership-payment', {
        body: { sessionId },
      });

      if (error) {
        console.error('Payment verification error:', error);
        throw error;
      }

      return result;
    },
    onSuccess: (data) => {
      console.log('Payment verified successfully:', data);
      toast({
        title: "Membership Activated",
        description: "Your membership has been successfully activated!",
      });
    },
    onError: (error) => {
      console.error('Payment verification error:', error);
      toast({
        title: "Verification Error",
        description: "Failed to verify payment. Please contact support.",
        variant: "destructive",
      });
    },
  });
};
